<template>
  <div class="modal fade" tabindex="-1" role="dialog" ref="modal"  aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header" style="background: #3498db; color: white; padding: 30px;">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <template v-if="!$user.isSe() && $user.isFreeTrial() && action === 'quota'">
            <h4 class="modal-title">Oops, it seems that you are limited by your plan !</h4>
          </template>
          <template v-else-if="action === 'blockchain'">
            <h4 class="modal-title">You must upgrade your plan and benefit from file protection</h4>
          </template>
          <template v-else>
            <h4 class="modal-title">Upgrade your plan to access more !</h4>
          </template>
        </div>
        <div class="modal-body">
          <template v-if="action === 'quota'">
            <template v-if="$user.isFreeTrial()">
              <div class="row">
                <h3 aria-level="2" class="text-center">
                  <strong class="m-b" style="line-height: 30px;">Scan Science and Technology </strong><br>
                  Contact Leading Edge Experts & Companies
                </h3>
                <div style="text-align: center;">
                  <img :src="api_url + '/img/ampoule.png'" style="height: 90px;">
                </div>
                <div class="text-center" style="margin-top: 45px">
                  <div class="font-bold" style="font-size: large;">Thank you for testing our service! <br>
                    Additional searches and fuller service can be accessed by <a href='/user/register'>free sign-up</a></div>
                </div>
                <div class="text-center" style="margin-top: 25px">
                  <button class="btn btn-info btn-lg" @click="close" style=" border-radius: 4px;"> View plans</button>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="text-center">
                <h4>You have reached the maximum number of monthly queries allowed by your plan</h4>
              </div>
              <div class="text-center" style="margin-top: 45px">
                <div>If you do not want to wait until your allowance is reset, you can upgrade your plan and benefit
                  from higher privileges
                </div>
              </div>
            </template>
          </template>
          <template v-else-if="action === 'blockchain'">
            <div class="row" style="margin-top: 25px">
              <div class="col-xs-12 col-md-8 col-md-offset-2" style="font-size: large;">
                Blockchain-based ‘timestamping’ is a seamless and secure mechanism that offers you:
              </div>
            </div>
            <div class="row m-t" >
              <div class="col-xs-12 col-md-8 col-md-offset-2" style="font-size: medium;">
                <ul>
                  <li>Certainty on your file integrity</li>
                  <li>Certainty on the recording date</li>
                  <li>Confidentiality & auditability of your file<span class="text-info">*</span></li>
                </ul>
              </div>
            </div>
            <div class="row" style="margin-top: 15px">
              <div class="col-xs-12 col-md-8 col-md-offset-2" style="font-size: large;">
                This way, you can
              </div>
            </div>
            <div class="row m-t" >
              <div class="col-xs-12 col-md-8 col-md-offset-2" style="font-size: medium;">
                <ul>
                  <li>keep track of all versions and contributions to an asset</li>
                  <li>automatically gather evidence</li>
                  <li>Take reasonable steps to protect IP and better demonstrate ownership/authorship</li>
                </ul>
              </div>
            </div>
            <div class="row m-t">
              <div class="col-xs-6 text-center">
                <a class="btn btn-info btn-outline"
                   href="https://academy.idexlab.com/hc/en-us/articles/360022046879-Innovation-protection-principles"
                   target="_blank"> More information
                </a>
              </div>
              <div class="col-xs-6 text-center">
                <a class="btn btn-info"
                   href="mailto:sales@idexlab.com?subject=I’d like to know more about file protection">&nbsp; &nbsp; &nbsp; Next &nbsp; &nbsp; &nbsp;</a>
              </div>
            </div>

            <div class="text-center panel-footer" style="margin-top: 25px">
              <span class="text-info">*</span> Only your file identifier is stored in a public blockchain that is easy to audit
            </div>
          </template>
          <template v-else-if="action === 'advanceNews'">
            <div class="row" style="margin-top: 25px">
              <div class="col-xs-12 col-md-8 col-md-offset-2" style="font-size: large;">
                Integrate news feed aggregated from multiple, selected sources into your literature review.
              </div>
            </div>
            <div class="row" style="margin-top: 15px">
              <div class="col-xs-12 col-md-8 col-md-offset-2" style="font-size: large;">
                This integration into your biblio space will allow you to:
              </div>
            </div>
            <div class="row m-t" >
              <div class="col-xs-12 col-md-8 col-md-offset-2" style="font-size: medium;">
                <ul>
                  <li> Add news to your biblio boxes in addition to Scientific papers and Patents</li>
                  <li>Automate news monitoring on specific topics</li>
                  <li>Identify new companies becoming active your fields of interest</li>
                </ul>
              </div>
            </div>
            <div class="row m-t">
              <div class="col-xs-6 text-center">
                <a class="btn btn-info btn-outline hide"
                   href="https://academy.idexlab.com/hc/en-us/articles/360022046879-Innovation-protection-principles"
                   target="_blank"> More information
                </a>
              </div>
              <div class="col-xs-6 text-center">
                <a class="btn btn-info"
                   href="mailto:sales@idexlab.com?subject= I’d like to know more about the Advanced News service ">&nbsp; &nbsp; &nbsp; Next &nbsp; &nbsp; &nbsp;</a>
              </div>
            </div>
          </template>
          <template v-else>
            <h3 aria-level="2" class="text-center">
              <strong class="m-b" style="line-height: 30px;">Scan Science and Technology </strong><br>
              Contact Leading Edge Experts &amp; Companies
            </h3>
            <div style="text-align: center;">
              <img :src="api_url + '/img/ampoule.png'" style="height: 90px;">
            </div>
            <div class="row">
              <div class="text-left" style="display: flex; align-items: center; justify-content: space-evenly;flex-direction: column;">
                <div class="m-t-xs m-b" style="font-size: large;">
                  <template v-if="$user.isBasic()">
                    <p class="m-b-xs"><i class="fa fa-check"></i> Save, organise, share, bookmark your findings</p>
                    <p class="m-b-xs"><i class="fa fa-check"></i> Access more advanced content (Science, Patents, Companies)</p>
                    <p class="m-b-xs"><i class="fa fa-check"></i> Design step-by-step innovation projects</p>
                    <p class="m-b-xs"><i class="fa fa-check"></i> Collaborate with colleagues and partners </p>
                  </template>
                  <template v-else>
                    <p class="m-b"><i class="fa fa-check"></i> Benefit from additional search credits and project storage </p>
                    <p class="m-b"><i class="fa fa-check"></i> Send personalised emails to experts and companies that matter to your innovation</p>
                    <p class="m-b"><i class="fa fa-check"></i> Keep record of your interactions </p>
                  </template>
                </div>
              </div>
            </div>
            <div class="row text-center m-b-xs"><span style="font-style: italic; font-size: 14px;"> 15 days free trial</span>
            </div>
            <div class="text-center">
              <button class="btn btn-info btn-lg" @click="close" style=" border-radius: 4px;"> Upgrade </button>
            </div>
            <div class="row text-center m-t-xs m-b-xs">
              <span style="font-style: italic; font-size: 14px;"> View plans</span>
            </div>
            <div class="row text-center m-t m-b" style="font-size: large;">
              No commitment, secure and confidential
            </div>
          </template>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import VueLadda from 'vue-ladda'

export default {
  components: {VueLadda},
  name: 'LimitPlan',
  props: {
    onHidden: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      action: null,
      planMessage: 'Silver plan or higher',
      api_url: process.env.API_URL
    }
  },
  methods: {
    show: function (action) {
      this.action = action
      $(this.$refs.modal).modal('show')
    },
    close: function (e) {
      e.preventDefault()

      $(this.$refs.modal).modal('hide')

      if (this.$user.isSe()) {
        this.$router.push({name: 'LeaPlans'})
      } else {
        this.$router.push({name: 'Plans'})
      }
    },
    submitForm: function (e) {
    }
  },
  mounted () {
    $(this.$refs.modal).on('hidden.bs.modal', (e) => {
      this.onHidden()
    })
  },
  beforeMount () {
    if (this.$auth.user().profile.id !== 1 && !this.$user.isSme()) {
      this.planMessage = 'Business or Corporate plan'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LimitPlan.vue